import { AlertTriangle } from "lucide-react";

export function ErrorItem({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="px-3 py-2 border border-red-500/30 rounded-lg bg-red-500/5 text-sm select-text">
      <div className="flex items-start gap-2 text-red-400">
        <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" />
        <span>{message}</span>
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-2 ml-6 px-3 py-1 text-xs font-medium rounded-md border border-red-500/30 text-red-400 hover:bg-red-500/10 transition-colors"
        >
          Retry
        </button>
      )}
    </div>
  );
}
